<template>
  <v-navigation-drawer
    :model-value="show"
    color="primary"
    temporary
    location="right"
    width="600"
    @update:modelValue="change"
  >
    <div class="pa-8">
      <div class="d-flex justify-space-between align-center">
        <h1 class="text-white mt-6">Ideas</h1>
        <v-btn @click="show = false" icon color="white"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <p class="mb-4 text-white" style="font-size: 12px">
        Browse through your own ideas or ask Stix AI to generate new idea
        suggestions for your business.
      </p>

      <v-tabs
        class="ml-2"
        height="35"
        background-color="transparent"
        hide-slider
        selected-class="active-tab"
        v-model="tab"
      >
        <v-tab style="border-radius: 6px 6px 0 0" class="tab mr-1">Ideas</v-tab>
      </v-tabs>
      <v-card flat class="pt-4" color="white">
        <div v-if="tab === 0">
          <div class="d-flex justify-space-between align-center mb-6 px-4">
            <AddIdea ref="editidea" />

            <v-text-field
              class="px-4"
              variant="solo"
              flat
              label="Search"
              hide-details=""
              density="compact"
              bg-color="smoke"
              style="border-radius: 6px"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
            ></v-text-field>
            <v-select
              label="Tags"
              bg-color="smoke"
              variant="solo"
              density="compact"
              style="border-radius: 8px; width: 150px"
              hide-details=""
              flat
              :items="tags"
              clearable
              v-model="tags_filter"
            ></v-select>
          </div>
          <div
            v-if="loading"
            style="width: 100%"
            class="d-flex justify-center mt-6"
          >
            <v-progress-circular
              indeterminate
              color="accent"
              width="2"
            ></v-progress-circular>
          </div>
          <v-data-table
            :headers="headers"
            :items="filtered"
            :items-per-page="5"
            hide-default-header
            style="cursor: pointer"
            :search="search"
            :loading="loading"
            @click:row="useItem"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-y-transition" bottom>
                <template v-slot:activator="{ props }">
                  <v-btn
                    variant="text"
                    v-bind="props"
                    icon="mdi-dots-vertical"
                    size="small"
                  >
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item link class="px-4" @click="use(item)">
                    <v-icon size="small" class="mr-3">mdi-send</v-icon>
                    Use
                  </v-list-item>
                  <v-list-item link class="px-4" @click="edit(item)">
                    <v-icon size="small" class="mr-3">mdi-pencil</v-icon>
                    Edit
                  </v-list-item>
                  <v-list-item link class="px-4" @click="deleteItem(item.uid)">
                    <v-icon size="small" class="mr-3">mdi-delete</v-icon>
                    Delete
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

            <template v-slot:[`item.tags`]="{ item }">
              <div class="d-flex flex-wrap" style="gap: 3px">
                <v-chip
                  size="x-small"
                  color="info"
                  variant="flat"
                  v-for="(t, index) in item.tags"
                  :key="index"
                  >{{ t }}</v-chip
                >
              </div></template
            >
          </v-data-table>
        </div>
      </v-card>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import AddIdea from "@/components/AddIdea.vue";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

export default {
  components: {
    AddIdea,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
      ideas: (state) => state.ideas.ideas,
      loading: (state) => state.loading.ideas,
      tags: (state) => state.ideas.tags,
    }),
    show: {
      get() {
        return this.$store.state.ideas.show;
      },
      set(value) {
        this.$store.commit("setIdeasShow", value);
      },
    },
    filtered() {
      let filtered = this.ideas;
      if (this.tags_filter) {
        filtered = filtered.filter((idea) => {
          return idea.tags.includes(this.tags_filter);
        });
      }
      return filtered;
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "title",
        },
        { text: "Tags", value: "tags", align: "start" },
        { text: "Actions", value: "actions", align: "end" },
      ],

      search: "",
      tab: 0,
      tags_filter: "",
    };
  },
  methods: {
    change(v) {
      if (!v) {
        this.show = false;
      }
    },
    deleteItem(i) {
      this.$store.dispatch("deleteIdea", i);
    },
    edit(i) {
      const child = this.$refs.editidea;
      child.edit(i);
    },
    async use(v) {
      this.$store.commit("setPostIdea", v);
      this.$store.commit("setPostAskChatDrawer", true);
      this.show = false;

      let i = v;
      console.log(i.url);
      if (i.url) {
        let prefix = "https://";
        let link = i.url;
        if (!i.url.includes("http")) {
          link = prefix.concat(i.url);
        }

        console.log("Getting link preview: " + link);
        const getPreview = httpsCallable(functions, "getLinkPreview");
        const res = await getPreview({
          url: link,
        });

        let v = res.data;
        console.log(v);
        this.$store.commit("setPostMedia", [
          {
            alt: v.images,
            type: "url",
            url: v.url,
            src: v.image,
            thumbnail: v.image,
            description: v.description,
            language: v.language,
            title: v.title,
          },
        ]);
      }
    },
    async useItem(click, row) {
      let v = row.item;
      console.log(v);
      this.$store.commit("setPostIdea", v);
      this.$store.commit("setPostAskChatDrawer", true);
      this.show = false;
      let i = v;
      if (i.url) {
        let prefix = "https://";
        let link = i.url;
        if (!i.url.includes("http")) {
          link = prefix.concat(i.url);
        }

        console.log("Getting link preview: " + link);
        const getPreview = httpsCallable(functions, "getLinkPreview");
        const res = await getPreview({
          url: link,
        });

        let v = res.data;
        console.log(v);
        this.$store.commit("setPostMedia", [
          {
            alt: v.images,
            type: "url",
            url: v.url,
            src: v.image,
            description: v.description,
            language: v.language,
            title: v.title,
          },
        ]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  background-color: white;
  border-radius: 6px 6px 0 0;
  text-transform: none;
  font-size: 12px;
  opacity: 0.6;
}
.active-tab {
  opacity: 1;
}

.stockphotos {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 60vh;
  overflow: scroll;
  &.small {
    img {
      max-height: 100px;
    }
  }

  &.medium {
    img {
      max-height: 150px;
    }
  }

  &.large {
    img {
      max-width: 100%;
    }
  }

  img {
    border-radius: 6px;
  }

  img:hover {
    outline: 2px solid #cfb8ff;
  }
}
</style>
